module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Picture-0ec9c3ed211c615e3d18200bc0562c73.svg";